import clsx from 'clsx';
import { forwardRef, HTMLAttributes, ReactNode } from 'react';

import styles from './ChartTooltip.module.scss';

export { ChartTooltipItem } from './ChartTooltipItem';
export { ChartTooltipLabel } from './ChartTooltipLabel';

export interface ChartTooltipProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  children: ReactNode;
}

export const ChartTooltip = forwardRef<HTMLDivElement, ChartTooltipProps>(
  ({ title, children, className, ...rest }, ref) => (
    <div className={clsx(styles.container, className)} ref={ref} {...rest}>
      <p
        className={styles.title}
        data-testid="chart-tooltip"
        data-chart-tooltip-title
      >
        {title}
      </p>
      <div className={styles.itemsContainer}>{children}</div>
    </div>
  )
);
